import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { userBranches } from 'src/app/tabms/models/admin/branch';
import { listResponseModel, SingleResponseModel, userInfo, userPaySlips } from 'src/app/tabms/models/base/base';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  private baseUrl = environment.baseUrl + 'Account';

  constructor(private http: HttpClient) {

  }

  GetBranchesByUser(id: any): Observable<listResponseModel<userBranches>> {
    let params = { userid: id };
    return this.http.get<listResponseModel<userBranches>>(`${this.baseUrl}/GetBranchesByUser`, { params: params });
  }

  GetUserLoginWithRoleData(id: any): Observable<SingleResponseModel<userInfo>> {
    let params = { userid: id };
    return this.http.get<SingleResponseModel<userInfo>>(`${this.baseUrl}/GetUserLoginWithRoleData`, { params: params });
  }

}
